export default {
	"f2ced422f2a66fa62f06be8bde84c065": "商品詳情頁_優惠券點擊",
	"e9f06f71fcfe171a150016bdd565ece8": "每季優惠",
	"a9d0729eb501e3a1acc133e6944d5ba2": "立即領取",
	"188bf11d280b8454d62879e9c4c74e03": "元",
	"42f30a7451eeece9782b1856bd1af168": "已領取"
}
